import type {BioIconProps} from '../../icons/common-types'

export default function BestValueRankingsLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-[500] text-white tablet:gap-1 tablet:text-base">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0.00 0.00 1232.00 1232.00" {...attributes}>
        <path
          fill="#ffffff"
          d="
  M 978.49 72.45
  A 1.36 1.35 -2.8 0 1 979.84 73.67
  Q 980.15 76.75 981.06 79.62
  A 13.47 13.40 -56.2 0 1 981.65 82.65
  Q 981.93 86.40 982.13 86.88
  C 983.04 89.09 983.10 92.89 983.74 94.92
  Q 984.60 97.64 988.13 114.45
  Q 990.42 125.33 993.04 133.84
  Q 999.16 153.67 1006.65 172.12
  C 1013.42 188.82 1022.22 205.82 1033.32 220.42
  Q 1040.66 230.06 1052.20 241.59
  Q 1061.38 250.76 1075.54 260.21
  Q 1085.63 266.95 1103.19 274.83
  Q 1117.56 281.28 1135.63 287.44
  Q 1141.45 289.42 1145.44 292.41
  C 1148.11 294.40 1151.40 298.37 1151.81 302.04
  C 1152.46 307.69 1151.21 310.13 1148.34 315.25
  A 3.97 3.96 -1.8 0 1 1147.08 316.59
  Q 1143.22 319.09 1140.68 319.93
  Q 1138.28 320.74 1127.05 323.77
  Q 1111.12 328.07 1095.88 334.86
  Q 1080.65 341.64 1067.51 351.78
  Q 1049.97 365.30 1037.08 381.30
  Q 1025.98 395.09 1016.16 413.81
  Q 1007.14 431.00 1000.48 449.21
  Q 993.29 468.84 987.16 489.96
  Q 986.00 493.98 984.13 499.95
  Q 982.00 506.80 981.06 509.91
  Q 977.36 522.29 974.53 527.01
  C 973.27 529.11 969.10 530.90 966.13 531.14
  Q 960.51 531.59 953.72 531.34
  Q 947.86 531.12 945.19 526.10
  Q 942.48 521.00 940.83 513.93
  C 939.19 506.86 937.11 499.59 935.57 493.59
  Q 928.33 465.46 926.34 459.14
  Q 918.01 432.77 906.45 410.54
  Q 896.88 392.14 881.40 374.99
  Q 879.75 373.17 878.03 371.10
  Q 875.71 368.30 872.14 365.11
  Q 865.87 359.50 862.00 356.27
  Q 841.86 339.45 816.92 331.36
  C 811.92 329.73 807.03 327.66 802.26 326.48
  Q 792.52 324.06 785.14 322.28
  Q 779.77 320.98 774.57 318.90
  C 769.75 316.96 765.88 314.23 766.41 308.37
  Q 766.89 303.16 770.75 300.00
  Q 775.74 295.93 779.98 293.75
  Q 792.07 287.55 806.85 281.30
  Q 818.83 276.23 833.96 267.95
  Q 874.20 245.91 899.80 207.83
  C 904.76 200.45 910.49 189.99 914.51 179.89
  Q 921.97 161.16 923.60 155.63
  Q 926.60 145.48 928.35 139.38
  Q 930.02 133.58 930.92 129.08
  C 931.87 124.30 932.95 120.06 933.81 115.25
  Q 936.42 100.67 937.75 94.42
  C 938.60 90.49 938.83 85.44 939.85 81.93
  A 4.53 4.21 -38.1 0 0 940.01 80.92
  C 940.08 78.13 939.91 73.62 942.53 72.55
  A 1.30 1.30 0.0 0 1 943.03 72.45
  L 978.49 72.45
  Z"
        />
        <path
          fill="#ffffff"
          d="
  M 1038.21 416.70
  C 1037.11 423.61 1037.43 430.94 1037.70 439.33
  C 1037.94 446.78 1037.05 451.80 1036.64 459.03
  C 1036.12 468.35 1036.48 479.88 1036.16 485.24
  Q 1035.74 492.31 1035.19 498.58
  Q 1034.53 506.07 1034.44 511.93
  Q 1034.07 533.28 1033.52 542.66
  C 1032.52 559.81 1033.64 573.75 1032.55 593.86
  C 1032.14 601.58 1032.70 608.29 1032.00 615.82
  C 1031.35 622.86 1031.32 630.61 1031.29 637.99
  C 1031.25 644.74 1029.82 651.81 1029.69 659.00
  A 5.18 4.82 -39.1 0 1 1029.52 660.21
  Q 1028.23 665.07 1028.11 668.37
  A 4.35 4.09 57.8 0 1 1027.84 669.75
  Q 1027.19 671.51 1026.72 674.63
  Q 1026.49 676.13 1025.63 679.52
  Q 1021.67 695.04 1012.81 711.07
  Q 1008.59 718.70 1004.95 722.95
  C 1000.07 728.64 996.36 733.27 991.35 738.04
  C 984.44 744.63 979.95 748.52 974.84 753.96
  C 966.99 762.31 956.52 772.12 948.50 780.14
  Q 874.05 854.54 834.70 892.95
  Q 834.42 893.22 832.07 895.57
  C 789.57 937.93 770.88 956.69 735.28 992.45
  C 731.99 995.76 727.25 1000.00 723.94 1003.44
  Q 714.73 1012.98 705.79 1021.79
  C 694.21 1033.20 678.21 1049.11 661.48 1065.98
  Q 613.13 1114.75 612.08 1115.84
  Q 606.42 1121.66 605.37 1122.62
  Q 599.71 1127.77 594.97 1132.82
  C 591.67 1136.34 587.64 1139.80 584.56 1143.06
  Q 572.79 1155.52 565.65 1160.92
  Q 553.52 1170.09 537.36 1176.61
  Q 535.41 1177.40 523.52 1180.47
  A 5.98 5.61 -50.2 0 1 522.13 1180.64
  Q 517.56 1180.60 513.06 1181.97
  A 2.23 2.12 -52.2 0 1 512.41 1182.07
  L 490.53 1182.07
  A 3.89 3.85 54.8 0 1 489.19 1181.83
  Q 485.86 1180.62 481.94 1180.65
  A 4.97 4.52 47.7 0 1 480.88 1180.55
  Q 455.83 1175.55 436.35 1159.17
  C 432.55 1155.98 428.47 1151.23 424.70 1147.86
  C 421.14 1144.68 419.36 1142.51 416.50 1139.57
  C 412.89 1135.87 409.62 1133.25 406.17 1129.56
  Q 404.75 1128.04 399.43 1122.81
  Q 379.64 1103.35 373.64 1097.59
  Q 372.51 1096.50 368.97 1092.73
  C 366.90 1090.52 364.78 1088.85 362.38 1086.44
  Q 336.34 1060.28 323.91 1048.01
  C 318.61 1042.78 315.74 1039.63 309.59 1033.59
  Q 290.93 1015.27 229.76 954.17
  Q 220.80 945.22 205.20 929.87
  Q 190.06 914.98 180.68 905.56
  Q 177.85 902.72 176.71 901.53
  Q 168.18 892.65 159.53 884.31
  Q 150.81 875.91 142.07 867.10
  Q 124.31 849.22 101.17 826.55
  Q 98.52 823.95 94.80 820.08
  Q 90.89 816.01 88.38 813.61
  Q 84.44 809.84 79.59 805.17
  Q 77.91 803.55 67.94 793.54
  Q 60.78 786.34 57.02 781.26
  C 45.50 765.72 37.42 747.44 35.64 728.18
  Q 35.31 724.54 35.33 714.39
  C 35.35 703.18 38.14 691.22 41.83 682.02
  Q 47.84 667.01 58.35 652.20
  Q 64.03 644.19 75.02 633.02
  Q 93.02 614.73 118.89 588.65
  Q 120.44 587.09 126.10 581.35
  Q 154.82 552.23 169.84 537.09
  Q 212.76 493.81 256.43 450.17
  Q 430.97 275.74 475.54 231.29
  C 479.57 227.27 485.98 221.32 491.14 215.90
  C 501.33 205.17 513.17 195.12 526.39 187.92
  Q 527.69 187.21 538.00 182.28
  Q 544.27 179.28 548.52 178.21
  C 552.98 177.08 557.86 175.40 563.16 174.59
  Q 578.77 172.22 580.37 171.92
  C 584.44 171.16 591.25 171.81 596.14 171.39
  Q 612.60 169.96 625.76 170.02
  Q 632.89 170.04 635.75 169.83
  C 640.46 169.47 644.06 170.04 649.07 169.60
  Q 652.77 169.28 656.85 169.27
  C 668.93 169.24 680.98 168.64 691.75 168.70
  Q 763.01 169.11 776.99 168.91
  Q 791.12 168.71 820.75 168.34
  Q 822.15 168.32 828.81 167.56
  C 837.00 166.63 845.62 167.35 854.02 166.34
  Q 862.38 165.34 867.83 165.02
  A 7.69 7.46 -53.0 0 0 869.37 164.78
  Q 874.02 163.55 879.29 163.71
  A 0.74 0.73 -83.5 0 1 879.99 164.60
  C 879.45 167.20 878.99 169.40 877.63 172.04
  Q 865.25 196.18 846.70 213.69
  Q 841.98 218.15 833.89 224.78
  Q 828.40 229.28 819.88 234.26
  C 810.23 239.89 802.93 243.90 793.63 247.64
  Q 765.68 258.88 756.04 263.52
  Q 753.35 264.82 745.73 269.83
  Q 738.96 274.29 736.22 277.22
  Q 727.76 286.26 725.16 297.09
  Q 724.44 300.10 725.02 310.32
  A 6.59 6.50 -56.4 0 0 725.36 312.07
  L 726.97 316.74
  A 6.47 6.19 -71.8 0 0 727.60 318.06
  Q 727.77 318.35 731.87 324.77
  C 733.60 327.47 736.50 330.31 739.06 332.28
  Q 748.38 339.45 761.14 343.85
  Q 769.87 346.86 775.94 348.41
  Q 786.88 351.19 790.84 352.61
  Q 798.04 355.18 810.64 360.46
  Q 813.78 361.77 817.87 364.23
  Q 835.69 374.91 850.40 388.33
  Q 861.02 398.03 873.60 415.79
  Q 876.94 420.51 880.46 427.48
  C 883.20 432.90 886.26 438.11 888.49 443.70
  Q 893.00 455.01 895.79 464.48
  Q 898.69 474.34 899.17 476.31
  Q 902.50 490.27 904.03 497.69
  C 904.53 500.09 904.65 502.66 905.19 504.68
  C 906.58 509.91 907.79 518.00 909.68 523.60
  Q 912.26 531.20 913.74 535.03
  C 919.19 549.15 930.28 562.59 945.55 566.35
  Q 947.67 566.87 950.29 567.63
  A 8.28 8.11 -34.8 0 0 952.13 567.94
  Q 956.35 568.16 961.04 568.51
  Q 965.75 568.86 969.93 568.19
  Q 977.37 566.99 982.79 564.80
  C 1003.13 556.55 1012.51 539.87 1018.02 519.21
  Q 1018.75 516.45 1019.95 512.11
  C 1021.41 506.80 1022.13 501.56 1022.93 497.53
  Q 1026.07 481.70 1026.54 476.30
  C 1026.72 474.25 1026.83 472.52 1027.24 470.91
  C 1028.70 465.13 1029.56 459.16 1030.95 453.30
  Q 1031.63 450.46 1032.00 446.48
  Q 1032.21 444.24 1033.81 437.14
  C 1035.40 430.06 1035.75 423.24 1037.32 416.41
  A 0.39 0.37 -79.8 0 1 1037.73 416.11
  L 1037.76 416.11
  A 0.51 0.51 0.0 0 1 1038.21 416.70
  Z
  M 682.04 513.22
  C 687.98 519.07 694.33 523.48 701.77 526.59
  C 706.73 528.66 710.35 530.56 715.55 531.23
  A 9.39 8.39 -29.8 0 1 716.82 531.50
  C 721.28 532.77 725.70 533.00 731.54 533.90
  C 736.15 534.61 743.05 534.15 748.81 533.13
  Q 766.52 529.97 782.27 520.05
  Q 785.22 518.19 786.45 517.08
  C 789.85 513.99 793.39 511.42 795.95 508.48
  Q 806.64 496.23 810.84 485.96
  Q 818.65 466.87 816.80 443.04
  C 816.55 439.72 815.71 437.52 815.14 434.28
  Q 814.63 431.31 813.54 427.83
  C 806.91 406.68 792.60 389.78 772.58 380.20
  Q 766.05 377.08 761.54 375.71
  Q 760.54 375.41 751.66 373.33
  Q 746.64 372.15 741.63 372.06
  Q 728.48 371.84 720.51 372.11
  A 6.50 6.28 -52.3 0 0 719.01 372.33
  Q 706.84 375.71 702.09 377.87
  Q 685.89 385.22 673.53 400.54
  Q 669.78 405.19 666.67 412.17
  Q 662.12 422.37 661.22 425.40
  Q 660.19 428.91 659.41 433.35
  Q 658.67 437.55 658.36 438.73
  Q 657.65 441.41 657.57 444.18
  Q 657.36 451.29 657.53 460.02
  Q 657.63 464.91 658.90 470.41
  Q 660.77 478.54 661.40 480.61
  Q 663.69 488.23 669.49 498.24
  C 672.65 503.70 677.24 508.50 682.04 513.22
  Z"
        />
      </svg>

      <span>Best Value Rankings</span>
    </div>
  )
}
